module.exports = __webpack_public_path__ + "img/bre6.92db15c2.png";